<template>
  <div class="NewApproveLine">
    <div class="box-card">
      <el-row v-if="subApproveType">
        <el-col :span="5" style="padding: 16px; text-align: right"
          >选择审批流分类：</el-col
        >
        <el-col :span="14">
          <el-select
            :value="subType"
            placeholder="-请选择-"
            @change="changeSecondApproveType"
            style="width: 100%"
          >
            <el-option
              v-for="option in secondList"
              :key="option.label"
              :label="option.value"
              :value="option.label"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div v-for="(item, index) in departList" :key="index" class="text item">
        <el-row>
          <el-col :span="5" style="padding: 16px; text-align: right"
            >{{ item.jobName }}:&nbsp;&nbsp;</el-col
          >
          <el-col :span="14">
            <el-input
              size="medium"
              v-model="item.approveUserName"
              style="width: 100%"
              :readonly="true"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button
              @click="ShowMaskBoxFun(item, index)"
              type="primary"
              style="min-width: 60px; margin-left: 10px"
              >选择</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 审批人员选择设置弹窗 -->
    <select-user-dialog
      :visible="isShowMaskBox"
      @close="saveApproveRYBtn"
      title="选择审批人员"
      v-bind="approveDialogOptions"
    ></select-user-dialog>
  </div>
</template>

<script>
import {
  getApproveListService,
  getProjectGMListService, //获取相应部门人员列表
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
  selectSecondDataDetailService, //查询审批流二级字典详情
} from "@/services/sysSettingService";
import {
  getRealApproveListService, //查询审批列表
} from "@/services/approveServices";
import selectUserDialog from "./selectUserDialog";
export default {
  name: "NewApproveLine",
  props: {
    itemId: {
      type: Number,
      default: 0,
    },
    addoredit: {
      type: Boolean,
      default: false,
    },
    approveType: {
      //查询审批流模板查的类型
      type: String,
      default: "",
    },
    approveClass: {
      //查询审批人列表传得类型
      type: String,
      default: "",
    },
    subApproveType: {
      //查询审批人列表传得子类型，如果要二级分类查询，必传，不能为空（20231019）
      type: String,
      default: "",
    },
    subApproveName: {
      //找不到子类型时展示名字
      type: String,
      default: "",
    },
  },
  components: {
    selectUserDialog,
  },
  data() {
    return {
      departList: [], //审批流模板数组
      secondList: [], //二级审批流模板
      deptSelected: [], //选中的节点
      isShowMaskBox: false, //配置弹窗是否可见
      choiceindex: 0, //记录选择的索引值
      approveBMList: [], //部门列表
      approveRYList: [], //人员列表

      subType: "", //审批子类型
      flag: true, //审批子类型
      defaultProps: {
        id: "id",
        label: "name",
        isLeaf: "leaf",
        children: "children",
      },
      approveDialogOptions: {
        approveVO: {},
      }, // 审批流弹出框的配置
    };
  },
  mounted() {
    this.subType = this.subApproveType;

    if (this.subApproveType) {
      this.getSecondApproveType(); //获取二级审批流模板下拉列表
    } else {
      this.getDepartList(); //获取二级审批流模板配置流
    }
  },
  watch: {
    itemId(value) {
      if (value && value !== 0) {
        this.getApproveList(); //获取二级审批流模板配置流
      }
    },
    subApproveType(value) {
      this.subType = this.subApproveType;
      //二级审批流类型，例：分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      if (value && this.flag) {
        this.getSecondApproveType();
      } else {
        if (this.flag) this.getDepartList();
      }
    },
  },
  methods: {
    // 加载树结点
    loadNode(node, resolve) {
      // 如果是顶级的父节点
      if (node.level === 0) {
        // 查找顶级对象
        let reqParam = {
          pid: 0,
          orgId: sessionStorage.getItem("orgId"),
        };
        getDeptListService(reqParam)
          .then((res) => {
            if (res.code == 10000000) {
              return resolve(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.deptId = node.data.id;
        getsubDeptService(param)
          .then((res) => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach((item) => {
                item.leaf = item.isLeaf == 1;
              });
              return resolve(nodes);
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      }
    },

    changeSecondApproveType(val) {
      this.flag = false;
      this.subType = val;

      let param = this.secondList.find((item) => item.label == val);
      if (param) {
        this.$emit("saveApproveType", param);
      }
      this.clearShowMaskBox();
      this.getDepartList();
    },
    //获取一级审批流对应对应的二级字典
    getSecondApproveType() {
      let reqParam = {
        label: this.approveType,
        // orgId: sessionStorage.getItem("orgId"),
      };
      selectSecondDataDetailService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.secondList = res.data;
            let param = this.secondList.find(
              (item) => item.label == this.subApproveType
            );
            if (!param) {
              this.subType = this.subApproveName;
            } else {
              this.getDepartList();
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    /* 菜单点击回调事件 */
    handleNodeClick(deptNode) {
      // this.deptSelected = deptNode;
      this.departList[this.choiceindex].deptId = deptNode.id;
      this.getProjectGMList(deptNode.id);
    },
    //点击部门文本框触发事件
    ShowMaskBoxFun(item, val) {
      this.choiceindex = val;
      this.approveDialogOptions = {
        approveVO: item,
      };
      this.isShowMaskBox = true;
    },
    //获取审批列表项目经理下拉框数据
    getProjectGMList(deptId) {
      let param = {
        deptId: deptId,
        jobId: this.departList[this.choiceindex].jobId,
      };
      getProjectGMListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.approveRYList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {});
    },
    //获取审批流数据
    getDepartList() {
      let param = {};
      param.orgId = sessionStorage.getItem("orgId"); //组织id
      param.type = this.approveType; //类型
      if (this.subType) {
        param.subType = this.subType; // 分项合同子类型,供应商子类型
      }

      getApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.departList = [];
            let arr = res.data;
            // this.departList = res.data; //审批流模板
            for (let i = 0; i < arr.length; i++) {
              arr[i].approveUserId = "";
              arr[i].approveUserName = "";
              arr[i].deptId = "";
              arr[i].deptName = "";
              arr[i].sort = arr[i].sortId;
              if (arr[i].specialOperate == "0") delete arr[i].specialOperate;
             
              this.departList.push(arr[i]);
            }
            if (this.itemId !== 0 && this.flag) {
              this.getApproveList();
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },

    //获取已保存审批人列表
    getApproveList() {
      let param = {};
      param.itemId = this.itemId; //审批对象id
      param.approveClass = this.approveClass; //审批类型 例：合同
      getRealApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (res.data.length > 0) {
              let arr = res.data;
              if (arr[0].status == 99) {
                arr.splice(0, 1);
              }
              for (let i = 0; i < arr.length; i++) {
                if (
                  this.departList[i].sortId &&
                  this.departList[i].sortId == arr[i].sort
                ) {
                  this.departList[i].approveUserId = arr[i].approveUserId;
                  this.departList[i].deptId = arr[i].deptId;
                  this.departList[i].deptName = arr[i].deptName;
                  this.departList[i].sort = this.departList[i].sortId;
                  this.departList[i].approveUserName = arr[i].approveUserName;
                  delete this.departList[i].sortId;
                }
                let flag=arr.every(item=>item.status!=1&&item.status!=4)  
                this.$emit("saveApproveLine", this.departList,flag);
                this.$set(this.departList);
              }
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },

    //保存审批人员
    saveApproveRYBtn(data) {
      if (!data) {
        this.isShowMaskBox = false;
        return;
      }
      let item = this.departList[this.choiceindex];
      item.approveUserName = data.displayName || data.name;
      item.approveUserId = data.id;
      item.deptName = data.deptDisplayName;
      item.deptId = data.deptId;
      this.isShowMaskBox = false;
      this.$emit("saveApproveLine", this.departList);
    },
    //保存审批流部门审批人员列表
    saveApproveLine() {
      for (let i = 0; i < this.departList.length; i++) {
        delete this.departList[i].type;
        if (
          this.departList[i].approveUserId == "" ||
          null == this.departList[i].approveUserId
        ) {
          this.$alert("未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      this.$emit("saveApproveLine", this.departList);
      this.$alert("保存审批流成功", "提示", {
        confirmButtonText: "确定",
      });
    },
    //重置审批人员列表
    clearShowMaskBox() {
      this.departList.map((item) => {
        item.approveUserId = "";
        item.approveUserName = "";
        item.deptId = "";
        item.deptName = "";
        item.jobName = "";
      });
      // let arr = [...this.departList];
      // this.departList = [];
      // this.departList = arr;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.NewApproveLine {
  .timeDialog1 {
    /deep/ .el-dialog {
      width: 40%;
      height: 70%;

      .el-dialog__header {
        height: 24px;
      }

      .el-dialog__body {
        height: calc(100% - 114px);
      }
    }

    .maskBox {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .maskContent {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .tableList {
          height: calc(100% - 46px);

          .el-row {
            height: 100%;

            .el-col-12 {
              width: 46%;
              margin: 0 2%;
            }

            .el-col {
              height: 100%;

              .tableItem {
                height: 100%;
                overflow: hidden;
                border: 1px solid #ebeef5;

                .menuTitlePanel {
                  height: 49px;
                  line-height: 50px;
                  text-indent: 10px;
                  text-align: left;
                  border-bottom: 1px solid #ebeef5;
                }

                .el-tree {
                  height: calc(100% - 50px);
                  overflow: auto;
                }

                /deep/ .el-tree > .el-tree-node {
                  display: inline-block !important;
                  min-width: 51%;
                }

                /deep/ .el-table {
                  height: 100%;

                  th,
                  th.is-leaf {
                    background-color: #fff !important;
                  }

                  th > .cell {
                    font-size: 14px;
                    color: #444444;
                  }

                  .el-table__body-wrapper {
                    height: calc(100% - 50px);
                    overflow: auto;
                    tr td {
                      padding: 8px 0;
                    }
                  }
                }
              }
            }
          }
        }
        .dialog-footer {
          height: 36px;
          padding-top: 10px;
          text-align: center;
        }
      }
    }
  }
}
</style>
